var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-message",attrs:{"id":"errorWrapper"}},[_c('h1',[_vm._v("This search did not return any results")])])}]

export { render, staticRenderFns }